import React from 'react'

const ChannelBodyTemplate = ({ rowData }) => {
    return rowData.channel?.name
}

export default ChannelBodyTemplate
